// extracted by mini-css-extract-plugin
module.exports = {"header":"OpenTableReservation_header__9Uo8C","header-title":"OpenTableReservation_header-title__oH0QG","opentable-widget":"OpenTableReservation_opentable-widget__Wb5Gj"};